const commissionAddConsumeRule = () =>
  import('@/views/main/commission/add/consume/consume.vue')
export default {
  path: '/main/commission/addConsumeRule',
  name: 'commissionAddConsumeRule',
  component: commissionAddConsumeRule,
  children: []
}
